


























































































































































































































































































































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../lib/util'
    import AbpBase from '../../lib/abpbase'
    import TransferOrder from '../../store/entities/transferorder'
     const { jsPDFs } = require('@/lib/excel/html2pdf.bundle.min.js');
    const { ExcelPdf } = require('@/lib/excel/jspdf.js');
    
     
    
    @Component
    export default class DetailTransferOrder extends AbpBase{


        
        @Prop({type:Boolean,default:false}) value:boolean;
        user:TransferOrder=new TransferOrder();
        pname:string="";
        paddress:string="";
        pzipcode:string="";
        pphone:string="";

        cname:string="";
        caddress:string="";
        czipcode:string="";
        cphone:string="";
        cfranchiselicense:string="";//经营许可证

        vname:string="";
        vaddress:string="";
        vzipcode:string="";
        vphone:string="";
    

        hname:string="";
        htypenumber:string=""; //编码
        hchemicalproperties:string=""; //化学特性
        harmfulingredients:string="";
        hemergencyequipment:string=""; //应急设备
        hemergencymeasures:string=""; //晋级措施
        hphysicalcharacteristics:string=""; //形态
        packagingmethod:string=""; //包装方式
        quantity:number=0;//数量
        hdangerous:string="";//废物特性:
        hpurposelist:object=null;//外运目的
        hpurposeval:object=[];
        vtransportcertificateumber:string="";//道路运输号
        disposalmethodlist:object=[{id:1,name:"利用",checked:false},{id:2,name:"贮存",checked:false},{id:3,name:"焚烧",checked:false},{id:4,name:"安全填埋",checked:false},{id:5,name:"其他",checked:true}];//处置方式
        disposalmethod:object=['其他'];
                                             

        transportationtime:string="";
        transfertime:string="";
        signeetime:string=""; 
        ispartysrc= require("@/images/danghui.png");
        getdeclarestatustxt(id){
            var txt="-";
               var list =this.$store.state.transferorder.declarestatus;
             list.forEach(item=>{
                   if(id==item.id){
                    txt=item.name;
                    return txt;
                   }
             })
             return txt;
   }
   getdispatchcarstatustxt(id){
            var txt="-";
               var list =this.$store.state.transferorder.dispatchcarstatus;
             list.forEach(item=>{
                   if(id==item.id){
                    txt=item.name;
                    return txt;
                   }
             })
             return txt;
   }
   getsignstatustxt(id){
            var txt="-";
               var list =this.$store.state.transferorder.signstatus;
             list.forEach(item=>{
                   if(id==item.id){
                    txt=item.name;
                    return txt;
                   }
             })
             return txt;
   }
        save(){
            

            (this.$refs.userForm as any).validate(async (valid:boolean)=>{
                
                
                if(valid){
                    await this.$store.dispatch({
                        type:'transferorder/update',
                        data:this.user
                    });
                    (this.$refs.userForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);
                }
            })
        }
        cancel(){
            (this.$refs.userForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
               
              
            if(!value){
                this.$emit('input',value);
              
           
            }else{
                console.log(this.$store.state.transferorder.editTransferOrder)
                this.user=Util.extend(true,{},this.$store.state.transferorder.editTransferOrder);
                  
                  

                  if(this.$store.state.transferorder.editTransferOrder.productionWaste!=null){
                    this.pname=this.$store.state.transferorder.editTransferOrder.productionWaste.corporatename;
                    this.paddress=this.$store.state.transferorder.editTransferOrder.productionWaste.address;
                    this.pphone=this.$store.state.transferorder.editTransferOrder.productionWaste.phone;
                    this.pzipcode=this.$store.state.transferorder.editTransferOrder.productionWaste.zipcode;
                  }
                  if(this.$store.state.transferorder.editTransferOrder.collectionOffice!=null){
                    this.cname=this.$store.state.transferorder.editTransferOrder.collectionOffice.corporatename;
                    this.caddress=this.$store.state.transferorder.editTransferOrder.collectionOffice.address;
                    this.cphone=this.$store.state.transferorder.editTransferOrder.collectionOffice.phone;
                    this.czipcode=this.$store.state.transferorder.editTransferOrder.collectionOffice.zipcode;
                    this.cfranchiselicense=this.$store.state.transferorder.editTransferOrder.collectionOffice.franchiselicense;
                  }
                  if(this.$store.state.transferorder.editTransferOrder.transPorted!=null){
                    this.vname=this.$store.state.transferorder.editTransferOrder.transPorted.corporatename;
                    this.vaddress=this.$store.state.transferorder.editTransferOrder.transPorted.address;
                    this.vphone=this.$store.state.transferorder.editTransferOrder.transPorted.phone;
                    this.vzipcode=this.$store.state.transferorder.editTransferOrder.transPorted.zipcode;
                    this.vtransportcertificateumber=this.$store.state.transferorder.editTransferOrder.transPorted.transportcertificateumber;
                   
                  }
                     var wastecodeen="";
                     var wastecategorynameen="";
                       this.quantity=this.$store.state.transferorder.editTransferOrder.quantity;
                if(this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation!=null){
                   //  this.hpurposeid=this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation.purpose;
                    this.harmfulingredients=this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation.harmfulingredients;
                    this.hphysicalcharacteristics=  this.getPhysicalcharacteristicsTxt(this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation.physicalcharacteristics);
                    this.packagingmethod=this.getPackagingmethodTxt(this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation.packagingmethod);;
                    this.hpurposelist=   this.getPurposelist(this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation.purpose);
                   
                    this.hname=this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation.name;
                    this.hemergencymeasures=this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation.emergencymeasures;
                    this.hemergencyequipment=this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation.emergencyequipment;
                      if(this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation.wastecode!=null){
                        wastecodeen=this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation.wastecode.wastecodeen;
                        this.hdangerous=this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation.wastecode.dangerous;
                         if(this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation.wastecode.wastecategory!=null){
                        wastecategorynameen=this.$store.state.transferorder.editTransferOrder.hazardouswasteInformation.wastecode.wastecategory.nameen;
                       }
                      }
                  }
                  if(wastecategorynameen!="")
                    this.htypenumber=wastecategorynameen;
                  }
                  if(wastecodeen!=""){
                    this.htypenumber+="("+wastecodeen+")";
                  }

                  

                 

                       if(this.user.transfertime!=null){
                             
                        this.transfertime= this.getDateYMDString(new Date(this.user.transfertime)); //new Date(this.user.transfertime).toTimeString();
                       }
                      if(this.user.transportationtime!=null){

                        this.transportationtime=this.getDateYMDString(new Date(this.user.transportationtime));
                       }
                       if(this.user.signeetime!=null){

                        this.signeetime=this.getDateYMDString(new Date(this.user.signeetime));
                       }

                       this.getQrImg(this.user.ordernumber)
               //
            //下面小区
            //  var vcid=this.$store.state.goods.editGoods.vid;
            
                // var cid=this.area_ByVarea(vcid);
                
            
        }
        created() {
    
        }

        userRule={
           
        }
        
   getPhysicalcharacteristicsTxt(id){
        var txt="";
       var physicalcharacteristics=  this.$store.state.hazardouswasteinformation.physicalcharacteristics;
       physicalcharacteristics.forEach(item=>{
             if(item.id==id){
               txt= item.name;
               return txt;
             }

       })
       
     return txt;
    }
    getPackagingmethodTxt(id){
        var txt="";
     var packagingmethodlist=   this.$store.state.hazardouswasteinformation.packagingmethod
                    packagingmethodlist.forEach(x=>{
                    if(x.id== id){
                       txt=x.name;
                    }})
        return txt;
    }

    getPurposeTxt(id){
        var txt="";
       var purposelist=   this.$store.state.hazardouswasteinformation.purpose
                    purposelist.forEach(x=>{
                    if(x.id== id){
                        txt=x.name;
                    }})
        return txt;
    }

     getPurposelist(id){
        
        var plist=[];
       var purposelist=   this.$store.state.hazardouswasteinformation.purpose
                    purposelist.forEach(x=>{
                        var checked=false;
                        //var checked=false;
                    if(x.id== id){
                       checked=true;
                        this.hpurposeval=x.name;
                        plist.push({id:x.id,name:x.name,checked})
                    }else{
                        plist.push({id:x.id,name:x.name,checked})
                    } 
                    
                    })
        return plist;
    }

     getDateYMDString(currentDate) {
      //let currentDate = new Date();
      let year = currentDate.getFullYear();
      let month = currentDate.getMonth() + 1;  // 注意月份从0开始，需要加1
      let day = currentDate.getDate();
      currentDate.toDateString
      return year + "年" + month + "月" + day+"日";
    }
      getQrImg(data){

            	require.ensure( [], () => {
				/*	const { QRCodeTo } = require('@/lib/excel/qrcode.js');
                    //https://lf9-cdn-tos.bytecdntp.com/cdn/expire-1-M/qrcodejs/1.0.0/qrcode.min.js
                    // 获取用于显示二维码的元素
const qrcode = document.getElementById('qrcodelabel');
qrcode.innerHTML="";
// 要编码的数据
 //const data = 'https://www.example.com';
// 配置选项
data="https://www.baidu.com";
const options = {
  text: data, // 数据内容
  width: 80, // 宽度（像素）
  height: 80, // 高度（像素）
  colorDark: '#000000', // 前景色（黑色）
  colorLight: '#ffffff', // 背景色（白色）
   
};
 
// 创建二维码对象
 QRCodeTo(qrcode, options);
 */
 const { QRCodeTo } = require('@/lib/excel/uqrcode.js');
                    //https://lf9-cdn-tos.bytecdntp.com/cdn/expire-1-M/qrcodejs/1.0.0/qrcode.min.js
                    // 获取用于显示二维码的元素
const qrcode = document.getElementById('qrcode');
qrcode.innerHTML="";
// 要编码的数据
 //const data = 'https://www.example.com';
// 配置选项
 
const options = {
  data: data, // 数据内容
  size: 80, // 宽度（像素）
  
  areaColor: '#fff', // 前景色（黑色）
  foregroundImageBackgroundColor: '#000000', // 背景色（白色）
   
};
 
// 创建二维码对象
 QRCodeTo(qrcode, options);

               })
          

    }
    async exportPDF(flname) {
  var content:any=  this.$refs.pdfcnt
     if(flname==""){
        flname="myfile.pdf";
     }
            try {
        
               //  html2pdf(content);

             var opt = {
  margin:       2,
  filename:flname,     //'myfile.pdf',
  image:        { type: 'jpeg', quality: 0.98},
  html2canvas:  { scale: 2 },
  jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' },
  pagebreak: { mode: ['avoid-all', 'css'] }
};
 
    ExcelPdf(content, opt);
  

      } catch(e) {
          console.log(e)
      }
   
 
     //参考https://github.com/eKoopmans/html2pdf.js#options
   
   
 
    }

    savepdf(){
        
         var flname="";
           if(this.user.ordernumber!=""&&this.user.ordernumber.length>0){
              flname=this.user.ordernumber+".pdf";
           }
           
           this.exportPDF(flname)
    }

    }


      
